import styled from "@emotion/styled";
import { FC } from "react";

const Container = styled("div")({
    display: "flex",
    gap: 24,
    marginTop: 32,
    justifyContent: "space-between",
    width: "100%",
    maxWidth: "900px",
    marginLeft: "auto",
    marginRight: "auto",
    breakInside: "avoid",
    pageBreakInside: "avoid",
});

const SignatureColumn = styled("div")({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "50%",
});

const SignatureTable = styled("table")({
    borderCollapse: "collapse",
    width: "100%",
});

const SignatureCellLabel = styled("td")({
    background: "#eae5de",
    border: "1px solid #222",
    padding: "4px 12px",
    width: "35%",
    fontSize: 13,
});

const SignatureCellValue = styled("td")({
    border: "1px solid #222",
    padding: "4px 12px",
    fontWeight: 700,
    fontSize: 13,
    textAlign: "center",
});

const SignatureCellEmpty = styled("td")({
    border: "1px solid #222",
    padding: "4px 12px",
    fontSize: 13,
    textAlign: "center",
});

const SignatureRow = styled("tr")({});

const SignatureSpace = styled("td")({
    border: "1px solid #222",
    height: 48,
});

const SignatureDescription = styled("div")({
    width: "100%",
    textAlign: "center",
    fontSize: 13,
    marginTop: 4,
});

interface SignatureBoxProps {
    createdBy: string;
}

const SignatureBox: FC<SignatureBoxProps> = ({
    createdBy,
}) => (
    <Container>
        <SignatureColumn>
            <SignatureTable>
                <tbody>
                    <SignatureRow>
                        <SignatureCellLabel>Wystawił(a)</SignatureCellLabel>
                        <SignatureCellValue>{createdBy}</SignatureCellValue>
                    </SignatureRow>
                    <SignatureRow>
                        <SignatureSpace colSpan={2} />
                    </SignatureRow>
                </tbody>
            </SignatureTable>
            <SignatureDescription>
                Podpis osoby upoważnionej do wystawienia zamówienia
            </SignatureDescription>
        </SignatureColumn>
        <SignatureColumn>
            <SignatureTable>
                <tbody>
                    <SignatureRow>
                        <SignatureCellLabel>Odebrał(a)</SignatureCellLabel>
                        <SignatureCellEmpty />
                    </SignatureRow>
                    <SignatureRow>
                        <SignatureSpace colSpan={2} />
                    </SignatureRow>
                </tbody>
            </SignatureTable>
            <SignatureDescription>
                Podpis osoby upoważnionej do odbioru zamówienia
            </SignatureDescription>
        </SignatureColumn>
    </Container>
);

export default SignatureBox;